import { flagg } from "@intelligems/ig-vendors/flagg/core/core";
import { localStore } from "@intelligems/ig-vendors/flagg/store/local-store";

export const definitions = {
  aiQa: {
    default: false,
    description: "Enable AI QA in the Experiment Preview tab",
  },
};

export const featureFlags = flagg({
  store: localStore(),
  definitions,
});
